
export function dicomDateToDate(strDate) {
  if (!strDate) { return new Date(NaN) }
  const tryIso = new Date(strDate)
  if (!isNaN(tryIso.getTime())) { return tryIso}
  const ints = strDate.replace(/(\d{4})(\d\d)(\d\d)/, "$1 $2 $3").split(" ");
  return new Date(
    parseInt(ints[0], 10),
    parseInt(ints[1], 10)-1,
    parseInt(ints[2], 10)
  );
}


export const getKeyImageNameOrPlaceholder = (keyImage, index) => keyImage.name || '' || ('Key Image #' + (index + 1))



// WEBPACK FOOTER //
// ./~/report-components/src/lib/index.jsx